// api config
const backendHost = process.env.REACT_APP_API_URL;
export const HOST_ROOT = `${backendHost}`;
export const API_ROOT = `${backendHost}/api`;
export const ACCEPT_HEADER = { headers: { 'Accept-Language': 'en' } };
